const APPLICATION_KEY = "@lucralizeTech:";

const LocalStorageUtils = {
  getItem(key: string) {
    return localStorage.getItem(`${APPLICATION_KEY}${key}`);
  },

  setItem(value: string, key: string) {
    localStorage.setItem(`${APPLICATION_KEY}${key}`, value);
  },

  clear() {
    localStorage.clear();
  },
};

export default LocalStorageUtils;
